import React from 'react';
import { useParams } from 'react-router-dom';
import withModal from 'hoc/with-modal';
import Form from 'components/form';
import Button from 'components/button';
import NodePreview from 'components/node-preview';
import { Content, GlobalLinkIcon, Title, NodeContainer } from './style';
import { Row, WithMargin } from 'components/layout';
import useTranslateWindowPointToCanvas from 'components/canvas/hooks/use-translate-window-point-to-canvas';
import { useGlobalLinks } from 'state/canvas/node-linking/global-links';
import { useTranslation } from 'i18n';
import { useNodeLinking } from 'state/canvas/node-linking';

const indicatorPosition = {
  x: window.innerWidth - 30,
  y: 140,
};

function GlobalLinkZoneModal({ modal, data }) {
  const { t } = useTranslation();
  const { id: surface } = useParams<{ id: string }>();
  const [_, { showLinkArrow }] = useNodeLinking(surface);
  const [[globalLink], { removeGlobalLink }] = useGlobalLinks();

  const translatePointToCanvas = useTranslateWindowPointToCanvas(surface);

  function cancelLink() {
    setTimeout(() => removeGlobalLink(globalLink), 500);
    modal.hide();
  }

  function finishGlobalLinking() {
    modal.hide();
    const linkStartPosition = translatePointToCanvas(indicatorPosition);
    showLinkArrow(globalLink.from, linkStartPosition);
  }

  if (globalLink && data.node) {
    const { node } = data;

    return (
      <>
        <Form.Header>
          <Button label={t('Close')} onClick={modal.hide} secondary />
          <Row>
            <Button label={t('Cancel link')} onClick={cancelLink} secondary />
            <WithMargin left="16px">
              <Button
                label={t('Finish link')}
                iconLeft={<GlobalLinkIcon />}
                onClick={finishGlobalLinking}
                quaternary
              />
            </WithMargin>
          </Row>
        </Form.Header>
        <Content>
          <Title>{t('Finish linking this node')}</Title>
          <NodeContainer>
            <NodePreview node={node} isSelected={false} />
          </NodeContainer>
        </Content>
      </>
    );
  }

  return null;
}

export default withModal(GlobalLinkZoneModal);
